import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PersonEntity } from '@nk/data-entities-lib';
import * as dayjs from 'dayjs';

const YEAR_TODAY = dayjs().year();

@Component({
  selector: 'nk-person-birth-date',
  imports: [TranslateModule, DatePipe],
  templateUrl: './person-birth-date.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PersonBirthDateComponent<T extends Pick<PersonEntity, 'birth_year' | 'birth_date'>> {
  public person = input<T | null>(null);

  public getYears = computed(() => {
    const person = this.person();
    if (!person) {
      return 0;
    }

    // First check if birth_year is available
    if (person.birth_year) {
      return YEAR_TODAY - person.birth_year;
    }

    // If not, try to extract year from birth_date
    if (person.birth_date) {
      const birthDate = dayjs(person.birth_date);
      if (birthDate.isValid()) {
        return YEAR_TODAY - birthDate.year();
      }
    }

    return 0;
  });

  public birthDate = computed(() => {
    const person = this.person();
    if (!person) {
      return null;
    }
    if (person.birth_date) {
      const birthDate = dayjs(person.birth_date);
      if (birthDate.isValid()) {
        return birthDate.toDate();
      }
    }
    return null;
  });
}
